import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'truncateArray',
})
export class TruncateArrayPipe implements PipeTransform {
  transform(values: any[], limit: number): any[] {
    return JSON.parse('' + JSON.stringify(values)).splice(0, limit);
  }
}
